var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31771)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_31771)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3466 7C24.0794 7 26.2948 9.2153 26.2948 11.9481C26.2948 14.2901 22.7262 19.5475 21.3466 21.9372C19.967 19.5475 16.3984 14.2901 16.3984 11.9481C16.3984 9.2153 18.6138 7 21.3466 7ZM21.3466 9.93434C22.4542 9.93434 23.3521 10.8322 23.3521 11.9398C23.3521 13.0474 22.4542 13.9453 21.3466 13.9453C20.239 13.9453 19.3411 13.0474 19.3411 11.9398C19.3411 10.8322 20.239 9.93434 21.3466 9.93434Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5737 27.8189V31.7052H9.42578V27.8189H35.5737Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8901 32.2052V35H11.3496V32.2052H12.8901Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0815 32.2052V35H31.541V32.2052H33.0815Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5258 22.9352C18.1371 22.9155 18.6309 22.4095 18.6309 21.7937C18.6309 21.1654 18.117 20.6515 17.4887 20.6515H13.8394C13.2112 20.6515 12.6973 21.1654 12.6973 21.7937C12.6973 22.4208 13.2095 22.9341 13.8362 22.9359H13.8394L17.5258 22.9352Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42578 27.3189H35.5737V25.3757C35.5737 24.307 34.6994 23.4324 33.6306 23.4326L11.2511 23.4362V15.6267C11.2511 15.1247 10.8405 14.714 10.3385 14.714C9.83652 14.714 9.42578 15.1247 9.42578 15.6267V25.3757V26.3051V27.3189Z",
    fill: "#00994E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_31771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8.5 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.353c158b544e9f5fc79f34368e5dd929.svg";
export { ForwardRef as ReactComponent };